import React from 'react';
import { Amount, LiquidityAmount, PercentAmount } from '@akropolis-web/primitives';

import { FallbackedTotalUSD, Progress } from 'components';
import { FormattedAmountProps } from 'components/FormattedAmount/types';
import { FallbackedTotalUSD as FallbackedTotalUSDType } from 'domain/types';
import { Theme, styled } from 'core/styles';

export type FallbackedTotalUSDWithProgressProps = {
  formattedAmountProps?: Omit<FormattedAmountProps<Amount>, 'sum'>;
  progress: ProgressProps;
  colored?: boolean;
  getProgressColor?: (progress: PercentAmount, theme: Theme) => any;
  renderProgressLabel?: (progress: PercentAmount) => React.ReactNode;
  displayTokenAmounts?: boolean;
} & FallbackedTotalUSDType;

type ProgressProps = {
  value: LiquidityAmount;
  total: LiquidityAmount;
} | null;

export function FallbackedTotalUSDWithProgress({
  value,
  fallback,
  progress,
  colored = false,
  getProgressColor,
  renderProgressLabel,
  formattedAmountProps,
  displayTokenAmounts,
}: FallbackedTotalUSDWithProgressProps) {
  return (
    <AmountContainer>
      <FallbackedTotalUSD
        value={value}
        fallback={fallback}
        displayTokenAmounts={displayTokenAmounts}
        formattedAmountProps={{ colored, ...formattedAmountProps }}
      />
      {progress && (
        <Progress
          value={progress.value}
          total={progress.total}
          getColor={getProgressColor}
          renderProgressLabel={renderProgressLabel}
        />
      )}
    </AmountContainer>
  );
}

const AmountContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '0 15px',
}));
